import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { downloadFromApi } from '~/helpers/files/download-from-api'

/**
 * Téléchargement du rapport d'activité PDF (#12), de l'organisation ou d'une
 * session (#243) : un état « en cours » pour le bouton, un message en cas
 * d'échec plutôt qu'un clic sans effet.
 */
export function useReportDownload(path: string, fallbackName: string) {
  const { t } = useTranslation()
  const [downloading, setDownloading] = useState(false)

  const download = async () => {
    setDownloading(true)
    try {
      await downloadFromApi(path, fallbackName)
    } catch {
      toast.error(t('stats.report.failed'))
    } finally {
      setDownloading(false)
    }
  }

  return { download, downloading }
}
